import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";

class DashboardService {
  get(path, params = {}) {
    return axios
      .get(`${config.apiUrl}reports/${path}`, {
        headers: authHeader(),
        params: this.cleanParams(params),
      })
      .then((response) => response.data.data);
  }

  cleanParams(params) {
    return Object.keys(params).reduce((result, key) => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== "") {
        result[key] = params[key];
      }
      return result;
    }, {});
  }

  getFilterOptions() {
    return this.get("filters");
  }

  getSummary(filters) {
    return this.get("summary", filters);
  }

  getPatsPipeline(filters) {
    return this.get("pats/pipeline", filters);
  }

  getPatsTrend(filters) {
    return this.get("pats/trend", filters);
  }

  getPatsByServiceType(filters) {
    return this.get("pats/service-types", filters);
  }

  getPatsByBrand(filters) {
    return this.get("pats/brands", filters);
  }

  getSla(filters) {
    return this.get("sla", filters);
  }

  getTechnicians(filters) {
    return this.get("technicians", filters);
  }

  getInterventionTypes(filters) {
    return this.get("interventions/types", filters);
  }

  getTopParts(filters, top = 10) {
    return this.get("parts/top", { ...this.dateParams(filters), technicianId: filters.technicianId, top });
  }

  getStockHealth(top = 15) {
    return this.get("stock/health", { top });
  }

  getFinancialMonthly(filters) {
    return this.get("financial/monthly", this.dateParams(filters));
  }

  getFinancialSummary(filters) {
    return this.get("financial/summary", this.dateParams(filters));
  }

  dateParams(filters) {
    return { startDate: filters.startDate, endDate: filters.endDate };
  }

  getServiceLines(filters) {
    return this.get("financial/service-lines", this.dateParams(filters));
  }

  getContracts(filters) {
    return this.get("contracts", this.dateParams(filters));
  }

  getTopClients(filters, top = 10) {
    return this.get("clients/top", { ...filters, top });
  }

  getEquipments(top = 10) {
    return this.get("equipments", { top });
  }

  getHumanResources(filters) {
    return this.get("hr", this.dateParams(filters));
  }
}

export default new DashboardService();
